/** QuickPlan — Client API : fetch JSON (même origine, cookie de suite envoyé). */

export class ApiError extends Error {
  constructor(message, status, code) {
    super(message);
    this.status = status;
    this.code = code;
  }
}

export async function api(path, opts = {}) {
  const res = await fetch(`/api${path}`, {
    headers: { 'Content-Type': 'application/json' },
    ...opts,
    body: opts.body ? JSON.stringify(opts.body) : undefined,
  });
  if (!res.ok) {
    let msg = `Erreur ${res.status}`;
    let code;
    try { const j = await res.json(); msg = j.error || msg; code = j.code; } catch { /* réponse non JSON */ }
    throw new ApiError(msg, res.status, code);
  }
  return res.json();
}

/** URL du portail de la suite, déduite du sous-domaine courant :
 *  plan.quick-apps.fr → portail.quick-apps.fr. Null en local ou sur IP. */
export function portalUrl() {
  const host = window.location.hostname;
  if (host === 'localhost' || host === '127.0.0.1' || /^\d+(\.\d+)+$/.test(host)) return null;
  const labels = host.split('.');
  if (labels.length < 3) return null;
  return `${window.location.protocol}//portail.${labels.slice(1).join('.')}/`;
}
